export default function containsLowerChar(value) {
    var LOWER = /[a-z]/;
    return LOWER.test(value);
}
